import React from 'react';

const Security = () => {
  return <>Security Page</>;
};

export default Security;
